import globalStore from '@services/global.state';
import qs from 'qs';
import {getAllCasinoRedirect} from '@/common-pages/game-navigate';
import {goTo} from '@utils/route';

const createDefaultGameRoute = (route: string, defaultParams = {}) => {
  return function (params: any) {
    return {
      route,
      params: {
        ...defaultParams,
        ...params,
      },
    };
  };
};
const createMixLottery = createDefaultGameRoute('MixLottery');
const createMatka = createDefaultGameRoute('Satta');
const createOtherGame = createDefaultGameRoute('WebView', {
  header: true,
  hideAmount: true,
});
const createScratch = createDefaultGameRoute('Scratch', {
  hideInnerTitle: 1,
});
const createColor = createDefaultGameRoute('Color');
const createDice = createDefaultGameRoute('Dice');
const createKerala = createDefaultGameRoute('GameWebView', {
  type: 'kerala',
});
// goTo('Digit', {
//   id: item.id,
//   pickName: item.pickName,
//   pickGameType: item.cycle ? 'quick' : 'normal',
//   cycle: item.cycle,
// });

const createDigit = createDefaultGameRoute('Digit');

// color ✅
// dice ✅
// mix-lottery state-lottery ✅
// race ✅
// matka ✅
// kerala ✅
// quick 3d digit ❎
// 体育 ❎
// 其他游戏 ✅
const reflexRoute = new Map([
  ['/mix-lottery', createMixLottery],
  ['/game-satta', createMatka],
  ['/scratch', createScratch],
  ['/color', createColor],
  ['/dice', createDice],
  ['/game-kerala', createKerala],
  ['/digit', createDigit],
]);
// 解析gameUrlv2
export function isOtherGame(url?: string) {
  if (!url) {
    return true;
  }
  const isOther = /^https?/.test(url);
  if (isOther) {
    return true;
  }
  const [, paramsJson] = url.split('?');
  const params = qs.parse(paramsJson);
  return params.otherGame === 'true';
}

/**
 * @description 通过一个游戏id，获取其路由地址 包括SKYGAME 三方 体育
 * @param {Number | String} id
 * */
export async function getGameById(id: number, otherGame = false) {
  try {
    // 如果是webview，那么
    // 返回一个地址
    const {gameName, gameUrl} = await getAllCasinoRedirect(id, otherGame);
    const [routeLink, paramsJson] = gameUrl.split('?');
    const params = qs.parse(paramsJson);
    const isOther = /^https?/.test(routeLink);
    if (!isOther) {
      // 走本地路由
      const routeParams = reflexRoute.get(routeLink);
      params.gameName = gameName;
      return routeParams?.(params);
    } else {
      return createOtherGame({
        originUrl: gameUrl,
        headerTitle: gameName,
        gameName,
        gameUrl,
      });
    }
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function normalizeGamePush(id: number, otherGame = false) {
  if (!id) {
    return;
  }
  if (otherGame && !globalStore.token) {
    goTo('Login');
    return;
  }
  try {
    globalStore.globalLoading.next(true);
    const routeData = await getGameById(id, otherGame);
    console.log(routeData);
    if (routeData) {
      //scratch
      /// /scratch?path=detail/54
      goTo(routeData.route, routeData.params);
    }
  } catch (err) {
    return Promise.reject(err);
  } finally {
    globalStore.globalLoading.next(false);
  }
}
